import { Component, OnInit } from '@angular/core';
import { FilterType } from '../../models/filter-type';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-filter-chips',
  templateUrl: './filter-chips.component.html',
  styleUrls: ['./filter-chips.component.scss']
})
export class FilterChipsComponent implements OnInit {
  window: any = window;
  public selectedFilters: FilterType[] = [];


  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.getSelectedFilters();
  }

  getSelectedFilters() {
    this.commonService._selectedFiltersRefresh.subscribe((filters: FilterType[]) => {
      if (Array.isArray(filters))
        this.selectedFilters = [...filters];
    });
  }

  removeFilter(filter: FilterType, e: Event) {
    const idxOfFilter = this.selectedFilters.findIndex((a: FilterType) => a.filterName === filter.filterName);
    if (idxOfFilter >= 0) {
      this.selectedFilters = this.selectedFilters.filter((item: FilterType) => item.filterName !== filter.filterName);
    }
    const elem: HTMLElement = document.getElementById('ariaEventStatus') as HTMLElement;
    elem?.setAttribute('tabindex', '0');
    elem?.setAttribute('aria-label', `${filter.filterName} is removed from filter chips`);
    elem?.focus();
    const shouldRemoveFilterType = !this.selectedFilters.some((c: FilterType) => c.filterType === filter.filterType);
    this.commonService.trackFilterUpdates(true, 'remove', filter.filterType, filter.filterName, shouldRemoveFilterType);
    var self = this;
    setTimeout(() => {
      if (self.selectedFilters && self.selectedFilters.length > 0 && idxOfFilter > -1) {
        (document.getElementById(((self.selectedFilters[idxOfFilter]) + '_chips').trim()) as HTMLElement)?.focus();
      }
    }, 2000);
    this.commonService._postSelectedFilters.next(this.selectedFilters)
  }
}
